import { mkType, SchemaToType } from '@main/schema-utils';

import { AssessmentSectionPreview } from './assessmentSection';

export const AssessmentFormTemplatePreview = mkType({
  name: 'AssessmentFormTemplatePreview',
  comment:
    'Very limited subset of fields necessary to identify an assessment form template in the UI',
  fields: {
    id: {
      comment: 'The id of the assessment form template',
      type: 'id',
      modelName: 'assessmentFormTemplate',
    },
    title: {
      comment: 'The title of the assessment form template',
      type: 'string',
    },
  },
});

/** Override type */
export type AssessmentFormTemplatePreview = SchemaToType<
  typeof AssessmentFormTemplatePreview
>;

export const AssessmentFormTemplatePreviewWithSections = mkType({
  name: 'AssessmentFormTemplatePreviewWithSections',
  comment:
    'Subset of fields for an editable template from which assessment forms can be created',
  fields: {
    ...AssessmentFormTemplatePreview.fields,
    sections: {
      comment: 'The sections belonging to this template',
      type: AssessmentSectionPreview,
      list: true,
    },
  },
});

/** Override type */
export type AssessmentFormTemplatePreviewWithSections = SchemaToType<
  typeof AssessmentFormTemplatePreviewWithSections
>;
